  /**
   * Counter type
   */
  export enum CounterType {
    UNKNOWN = 0,
    ELECTRIC = 1,
    HOTWATER = 2,
    COLDWATER = 3,
    HEATALLOCATOR = 4,
    GASMETER = 5,
    HEATMETER = 6,
  }